// Utility functions for fee calculations
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-VU', {
    style: 'currency',
    currency: 'VUV',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

export const getSchoolLevel = (year) => {
  // Junior Preschool (new year level)
  if (year === 'JPRE') {
    return 'JPRE';
  }
  // Preschool (existing)
  if (year === 'PRE') {
    return 'PRE';
  }
  if (year === 'FND' || (year?.startsWith('Year ') && parseInt(year.replace('Year ', '')) <= 4)) {
    return 'Junior';
  }
  const yearNumber = parseInt(year?.replace('Year ', ''));
  if (yearNumber >= 5 && yearNumber <= 8) {
    return 'Middle';
  }
  if (yearNumber >= 9 && yearNumber <= 12) {
    return 'Senior';
  }
  return '';
};

// Check if a student is in EEC (either PRE or JPRE)
export const isEEC = (year) => {
  return year === 'PRE' || year === 'JPRE';
};

// Get missing billing info for a student (returns array of missing fields)
export const getMissingBillingInfo = (student) => {
  const missing = [];
  const schoolLevel = getSchoolLevel(student?.currentYear);

  // For EEC students (PRE or JPRE), check for required fields
  if (schoolLevel === 'PRE' || schoolLevel === 'JPRE') {
    // Fee component is required for EEC
    if (!student?.feeComponent) {
      missing.push('Fee Component');
    }
    // Citizenship is required for pricing tier (unless corporate)
    if (!student?.debenturesCorp && !student?.primaryCitizenship) {
      missing.push('Citizenship');
    }
  }

  return missing;
};

export const getStudentStatus = (student, allFamilyStudents = []) => {
  // If student is corporate, this takes precedence over everything
  if (student.debenturesCorp) {
    return 'Corporate';
  }
  
  // Check if any student in the family has Citizen/Long-Term status
  const hasLongTermInFamily = allFamilyStudents.some(familyStudent => {
    const startDate = new Date(familyStudent.firstAttendanceDate);
    const endDate = new Date();
    let years = 0;

    if (!isNaN(startDate.getTime())) {
      years = endDate.getFullYear() - startDate.getFullYear();
      if (endDate.getMonth() < startDate.getMonth() || 
          (endDate.getMonth() === startDate.getMonth() && endDate.getDate() < startDate.getDate())) {
        years--;
      }
    }

    return familyStudent.primaryCitizenship === 'Vanuatu' || years > 2;
  });

  // If any family member is Citizen/Long-Term, apply it to this student
  if (hasLongTermInFamily) {
    return 'Citizen/Long-Term';
  }

  // Individual student check (fallback if no family member is long-term)
  const startDate = new Date(student.firstAttendanceDate);
  const endDate = new Date();
  let years = 0;

  if (!isNaN(startDate.getTime())) {
    years = endDate.getFullYear() - startDate.getFullYear();
    if (endDate.getMonth() < startDate.getMonth() || 
        (endDate.getMonth() === startDate.getMonth() && endDate.getDate() < startDate.getDate())) {
      years--;
    }
  }
  
  if (student.primaryCitizenship === 'Vanuatu' || years > 2) {
    return 'Citizen/Long-Term';
  }
  
  return 'Non-Citizen';
}; 